import React from 'react';
import { Check, Users, Building, GraduationCap } from 'lucide-react';
import Button from '../../components/Button/Button';
import './Memberships.css';

const Memberships: React.FC = () => {

  const plans = [
    {
      id: 'professional',
      icon: <Users size={40} />,
      name: 'Professional',
      description: 'For experienced racquet sports professionals seeking continuous growth and networking (e.g. directors, general managers, etc.)',
      features: [
        'All Student benefits',
        'Exclusive networking events',
        'One-on-one mentorship opportunities',
        'Priority access to job opportunities',
        'Complimentary BLXM course access',
      ],
      cta: 'Select',
      ctaLink: '/contact',
    },
    {
      id: 'student',
      icon: <GraduationCap size={40} />,
      name: 'Student',
      description: 'Perfect for students and emerging professionals looking to break into the racquet sports industry',
      features: [
        'Access to monthly industry presentations',
        'Networking opportunities with professionals',
        'Educational resources and webinars',
        'Job board access',
        'Discounts on BLXM course and retreats',
      ],
      cta: 'Select',
      ctaLink: '/contact',
    },
    {
      id: 'organization',
      icon: <Building size={40} />,
      name: 'Organization',
      description: 'Comprehensive solutions for clubs, facilities, and organizations',
      features: [
        'Customized training programs',
        'Staff development workshops',
        'Organizational consulting hours',
        'Industry benchmarking reports',
        'Custom content and presentations',
        'Annual strategic planning session',
      ],
      cta: 'Select',
      ctaLink: '/contact',
    },
  ];

  return (
    <div className="memberships">
      {/* Hero Section */}
      <section className="memberships-hero">
        <div className="container">
          <div className="memberships-hero-content">
            <h1 className="memberships-hero-title">Memberships</h1>
            <p className="memberships-hero-subtitle">
              Flexible membership options designed to support racquet sports professionals at every stage of their career
            </p>
          </div>
        </div>
      </section>

      {/* Membership Plans Section */}
      <section className="section memberships-plans">
        <div className="container">
          <div className="memberships-grid">
            {plans.map((plan) => (
              <div key={plan.id} className="membership-card-wrapper">
                <div className="membership-card">
                  <div className="membership-card-header">
                    <div className="membership-icon">{plan.icon}</div>
                    <h3 className="membership-plan-name">{plan.name}</h3>
                    <p className="membership-plan-description">{plan.description}</p>
                  </div>

                  <div className="membership-card-body">
                    <ul className="membership-features">
                      {plan.features.map((feature, index) => (
                        <li key={index} className="membership-feature">
                          <Check size={20} className="feature-check" />
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="membership-card-footer">
                    <Button
                      variant="primary"
                      size="medium"
                      href={plan.ctaLink}
                      fullWidth
                    >
                      {plan.cta}
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section memberships-cta-section">
        <div className="container">
          <div className="memberships-cta-content">
            <h2 className="cta-title">Not Sure Which Plan is Right for You?</h2>
            <p className="cta-subtitle">
              Schedule a free consultation with our team to discuss your goals and find the perfect membership
            </p>
            <Button variant="primary" size="large" href="https://calendar.app.google/zeaz1ocNpttMocbv7">
              Schedule Your Free Consultation
            </Button>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="section memberships-faq">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title text-center">Frequently Asked Questions</h2>
          </div>

          <div className="faq-grid">
            <div className="faq-item">
              <h3>Can I upgrade or downgrade my membership?</h3>
              <p>
                You can only upgrade your membership, not downgrade it. Contact us to discuss upgrading 
                to a plan that better suits your needs.
              </p>
            </div>

            <div className="faq-item">
              <h3>What payment methods do you accept?</h3>
              <p>
                We accept credit and debit cards for payment, nothing else.
              </p>
            </div>

            <div className="faq-item">
              <h3>Is there a discount for annual memberships?</h3>
              <p>
                Yes! Annual memberships receive a 15% discount compared to monthly billing. Contact us to 
                discuss annual membership options.
              </p>
            </div>

            <div className="faq-item">
              <h3>What's included in the BLXM course?</h3>
              <p>
                The Baseline Executive Mastermind Course is a comprehensive 12-week program featuring 10 
                modules, live sessions, personalized coaching, and lifetime access to materials. Visit our 
                BLXM Course page for complete details.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Memberships;

